"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initLendingMarketInstruction = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const buffer_layout_1 = require("buffer-layout");
const util_1 = require("../util");
const instruction_1 = require("./instruction");
const DataLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)("instruction"),
    (0, util_1.publicKey)("owner"),
    (0, buffer_layout_1.blob)(32, "quoteCurrency"),
]);
const initLendingMarketInstruction = (owner, quoteCurrency, lendingMarket, pythOracle, switchboardOracle, lendingProgram) => {
    const data = Buffer.alloc(DataLayout.span);
    DataLayout.encode({
        instruction: instruction_1.LendingInstruction.InitLendingMarket,
        owner,
        quoteCurrency,
    }, data);
    const keys = [
        { pubkey: lendingMarket, isSigner: false, isWritable: true },
        { pubkey: web3_js_1.SYSVAR_RENT_PUBKEY, isSigner: false, isWritable: false },
        { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
        { pubkey: pythOracle, isSigner: false, isWritable: false },
        { pubkey: switchboardOracle, isSigner: false, isWritable: false },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: lendingProgram,
        data,
    });
};
exports.initLendingMarketInstruction = initLendingMarketInstruction;
